import React from 'react';
import {connect} from 'react-redux'
import NewsItem from './NewsItem'
import MultiLangText from '../multilang/MultiLangText'




class NewsPage extends React.Component {

  constructor(){
    super();
    //console.log("This is the news page");

    //console.log("News Load",window.location);
    // is there a news article to load
    let currentSlug = window.location.pathname.split('/news/').join("")
    //console.log('news slug',currentSlug);

    this.state = {
       cols: [],
       articlesToShow: 6,
       currentSlug,
       currentCols: null
    }

    this.loadMoreArticles = this.loadMoreArticles.bind(this);

    this.resize = this.resize.bind(this)

  }



  splitIntoColoumns(){

    const news = this.props.newsData.data;
    let col1 = [], col2 = [], col3 = []

    // 3 coloumns
    for (let i=0; i < this.state.articlesToShow; i++) {

          // add the order for debugging
          news[i].order = i

          if(i % 3 === 0){

            col1.push(news[i])
          }
          if(i % 3 === 1){
            col2.push(news[i])
          }
          if(i % 3 === 2){
            col3.push(news[i])
          }
    }


    let cols = [col1,col2,col3]


    // 2 cols
    if(window.innerWidth < 769){

      col1 = [], col2 = []

      for (let i=0; i < this.state.articlesToShow; i++) {

            // add the order for debugging
            news[i].order = i

            if(i % 2 === 0){

              col1.push(news[i])
            }
            if(i % 2 === 1){
              col2.push(news[i])
            }


      }

      cols = [col1,col2]
    }

    // 1 col

    if(window.innerWidth < 481){
      cols = [this.props.newsData.data]
    }

    return  cols
    //this.setState({cols})

  }


  resize(){

    let currentCols = 3

      if(window.innerWidth < 769){
        currentCols = 2
      }

      if(window.innerWidth < 481){
        currentCols = 1
      }

      this.setState({currentCols})
  }

  componentWillMount(){
    //this.splitIntoColoumns()

  }

  componentDidMount(){
    this.findArticleViaSlug();
    window.addEventListener('resize',this.resize)
  }

  componentWillUnmount(){
    window.removeEventListener('resize',this.resize)
  }

  findArticleViaSlug(){



    this.props.newsData.data.map((item,i)=>{
      //console.log(item.slug,this.state.currentSlug);
        if(item.slug===this.state.currentSlug){
          //console.log("found it",item);
          //console.log((i>this.state.articlesToShow),i,this.state.articlesToShow);
          // Check if the item is not visible
          if(i>this.state.articlesToShow){
            //console.log(i,this.state.articlesToShow);
            let articlesToShow = i+1
            this.setState({articlesToShow})

          }
        //  console.log('Open News Item');
          // open the news item
          setTimeout(()=>{
            let newsItem = document.querySelector('.newsid-'+item.id);
                newsItem.querySelector('.read-more-link').click();
                newsItem.scrollIntoView();
          },3000)
        }
    });
  }

  loadMoreArticles(){

      let articlesToShow = this.state.articlesToShow + 3
        //console.log('loadMoreArticles ',articlesToShow);

      //console.log(articlesToShow,this.props.newsData.data.length,(articlesToShow > this.props.newsData.data.length));

      if(articlesToShow >= this.props.newsData.data.length){
        articlesToShow = this.props.newsData.data.length
      }

      this.setState({articlesToShow})


  }

  render() {

    //console.log("News",this);


    // split the work into rows

    let cols = this.splitIntoColoumns();

    //console.log('this.props.optionsData',this.props.optionsData);

    return (
      <div className="news-page scroll-anchor">
          <div className="news-container">
            <div className="news-list">
              {cols.map((col,i) => {

                  return(<div key={'r'+i} className="col">
                          {
                            col.map((item,j) => {
                                return (<NewsItem key={'n'+i+'_'+j} content={item} optionsData={this.props.optionsData}  />)
                            })
                          }
                        </div>)

                })

              }
            </div>
            {(this.state.articlesToShow !== this.props.newsData.data.length)?
                <div className="view-more-articles">
                    <div className="text" onClick={this.loadMoreArticles}><MultiLangText text={this.props.optionsData.data.read_more_articles} /></div>
                </div>
              : null
            }
          </div>

      </div>
    );
  }

}

const mapStateToProps = (state)=>{
    const newsData = state.KastnerStore.newsData
    const optionsData = state.KastnerStore.optionsData
  return {
      newsData,
      optionsData
  }
}

export default connect(mapStateToProps)(NewsPage);



// WEBPACK FOOTER //
// ./src/modules/news/NewsPage.js